import {
  Group,
  GroupTitle,
  LongTextField,
  ReferenceListField,
  useFieldLabel,
  useTabVisibility,
} from "ra-friendsofbabba";
import React from "react";
import { get } from "lodash";
import { TextField, useTranslate } from "react-admin";
import usePrivileges from "../usePrivileges";
import CannotViewField from "./CannotViewField";

const ProjectsField = ({ tab = 3, ...props }) => {
  const fieldLabel = useFieldLabel({
    resource: "technical-report-projects",
  });
  const translate = useTranslate();
  const visible = useTabVisibility(tab);
  const { canView } = usePrivileges({ ...props });
  if (!visible) {
    return null;
  }
  if (!canView) {
    return <CannotViewField {...props} source="projects" fullWidth />;
  }

  return (
    <Group wrapper>
      <GroupTitle
        title={translate(props?.source)}
        subTitle={translate("resources.technical-reports.fields.projects.help")}
      />

      <ReferenceListField
        {...props}
        tab={tab}
        perPage={5}
        reference="technical-report-projects"
        target="technical_report_id"
        additionalData={{
          executive_project_id: get(props, "record.executive_project_id"),
        }}
        addLabel={false}
        createLabel="ra.action.add_project"
        create={!props.disabled}
        modify={!props.disabled}
        remove={!props.disabled}
        mobilePrimaryText="name"
        mobileSecondaryText="collaboration_type.description"
        mobileTertiaryText="project_status.name"
        mobileBreakpoint="xs"
      >
        <LongTextField label={fieldLabel("name")} source="name" />
        <TextField
          label={fieldLabel("collaboration_type_id")}
          source="collaboration_type.description"
          sortBy="CollaborationTypes.description"
        />
        <TextField
          label={fieldLabel("project_status_id")}
          source="project_status.name"
          sortBy="ProjectStatuses.name"
        />
      </ReferenceListField>
    </Group>
  );
};

export default ProjectsField;
